import { AddressCheckAlertProps } from '@/components/Modals/AddressCheckAlert';
import { BirthdayUpdateAlertProps } from '@/components/Modals/BirthdayUpdateAlert';
import { DocumentDataMissingAlertProps } from '@/components/Modals/DocumentDataMissingAlert';
import { ExternalServiceDetailsAlertProps } from '@/components/Modals/ExternalServiceDetailsAlert';
import { InsuranceOrderRenewalAlertProps } from '@/components/Modals/InsuranceOrderRenewalAlert/InsuranceOrderRenewalAlert';
import { InsurancePhoneChangeAlertProps } from '@/components/Modals/InsurancePhoneChangeAlert';
import { LeavingWhileInProgressAlertProps } from '@/components/Modals/LeavingWhileInProgressAlert.tsx/LeavingWhileInProgressAlert';
import { PaymentDetailsAlertProps } from '@/components/Modals/PaymentDetailsAlert';
import { PayOrLeaveAlertProps } from '@/components/Modals/PayOrLeaveAlert';
import { ServiceDraftExistingAlertProps } from '@/components/Modals/ServiceDraftExistingAlert';
import { SocialProtectAppealInfoAlertProps } from '@/components/Modals/SocialProtectAppealInfoAlert';

export enum ModalName {
  BirthdayAlert = 'birthday_alert',
  AddressCheckAlert = 'address_alert',
  DocumentMissingAlert = 'document_missing_aler',
  DocumentAddCheckAlert = 'document_add_check_alert',
  ServiceDraftExistingAlert = 'service_draft_existing_alert',
  ServerErrorAlert = 'server_error_alert',
  PayOrLeaveAlert = 'pay_or_leave_alert',
  PaymentDetailsAlert = 'payment_details_alert',
  LeavingWhileInProgressAlert = 'leaving_while_in_progress_alert',
  ExternalServiceDetailsAlert = 'external_service_details_alert',
  InsurancePhoneChangeAlert = 'insurance_phone_change_alert',
  InsuranceOrderRenewalAlert = 'insurance-order-renewal-alert',
  SocialProtectAppealInfoAlert = 'social-protect-appeal-info-alert',
}

interface BaseRenderProps {
  modalName: ModalName;
}

export interface BirthdayAlertRender extends BaseRenderProps {
  modalName: ModalName.BirthdayAlert;
  modalProps: BirthdayUpdateAlertProps;
}

export interface AddressCheckAlertRender extends BaseRenderProps {
  modalName: ModalName.AddressCheckAlert;
  modalProps: AddressCheckAlertProps;
}

export interface DocumentMissingAlertRender extends BaseRenderProps {
  modalName: ModalName.DocumentMissingAlert;
  modalProps: DocumentDataMissingAlertProps;
}

export interface DocumentAddCheckAlertRender extends BaseRenderProps {
  modalName: ModalName.DocumentAddCheckAlert;
  modalProps?: never;
}

export interface ServiceDraftExistingAlertRender extends BaseRenderProps {
  modalName: ModalName.ServiceDraftExistingAlert;
  modalProps: ServiceDraftExistingAlertProps;
}

export interface ServerErrorAlertRender extends BaseRenderProps {
  modalName: ModalName.ServerErrorAlert;
  modalProps?: never;
}

export interface PayOrLeaveAlertRender extends BaseRenderProps {
  modalName: ModalName.PayOrLeaveAlert;
  modalProps: PayOrLeaveAlertProps;
}

export interface PaymentDetailsAlertRender extends BaseRenderProps {
  modalName: ModalName.PaymentDetailsAlert;
  modalProps: PaymentDetailsAlertProps;
}

export interface LeavingWhileInProgressAlertRender extends BaseRenderProps {
  modalName: ModalName.LeavingWhileInProgressAlert;
  modalProps: LeavingWhileInProgressAlertProps;
}

export interface ExternalServiceDetailsAlertRender extends BaseRenderProps {
  modalName: ModalName.ExternalServiceDetailsAlert;
  modalProps: ExternalServiceDetailsAlertProps;
}

export interface InsurancePhoneChangeAlertRender extends BaseRenderProps {
  modalName: ModalName.InsurancePhoneChangeAlert;
  modalProps: InsurancePhoneChangeAlertProps;
}

export interface InsuranceOrderRenewalAlertRender extends BaseRenderProps {
  modalName: ModalName.InsuranceOrderRenewalAlert;
  modalProps: InsuranceOrderRenewalAlertProps;
}

export interface SocialProtectAppealInfoAlertRender extends BaseRenderProps {
  modalName: ModalName.SocialProtectAppealInfoAlert;
  modalProps: SocialProtectAppealInfoAlertProps;
}

export type RenderModalProps =
  | BirthdayAlertRender
  | AddressCheckAlertRender
  | DocumentMissingAlertRender
  | DocumentAddCheckAlertRender
  | ServiceDraftExistingAlertRender
  | ServerErrorAlertRender
  | PayOrLeaveAlertRender
  | PaymentDetailsAlertRender
  | LeavingWhileInProgressAlertRender
  | ExternalServiceDetailsAlertRender
  | InsurancePhoneChangeAlertRender
  | InsuranceOrderRenewalAlertRender
  | SocialProtectAppealInfoAlertRender;
